import { css } from 'styled-components';
import ChevronDownSvg from 'assets/svgs/chevron--down.svg';
import ChevronRightSvg from 'assets/svgs/chevron--right.svg';

export const ExpanderIconStyles = css`
  .b-tree-icon.b-icon.b-icon-tree-leaf {
    display: none;
  }
  .b-icon-tree-expand:before {
    content: url(${ChevronRightSvg});
    width: 16px;
  }
  .b-icon-tree-collapse:before {
    content: url(${ChevronDownSvg});
    width: 16px;
  }
`;
export const GridStyles = css`
  .b-grid-row {
    border-bottom: 1px solid var(--table-border-color);
  }
  .b-grid-header:not(.b-sch-timeaxiscolumn) {
    padding: 0 var(--spacing-05);
  }
  .b-grid-header[tabindex='0'] {
    padding-left: var(--left-spacing);
  }
  .b-grid-row.b-selected {
    background: none;
    .b-focused:after {
      content: none;
    }
  }
  .b-gridbase.b-split .b-grid-splitter:not(.b-disabled) {
    flex: 0 0 1px;
  }
  .b-grid-header-container.b-grid-header {
    background: var(--coolest-gray-20);
    font-weight: var(--font-weight-bold);
    pointer-events: none;
  }
  .b-horizontaltimeaxis .b-sch-header-timeaxis-cell {
    border-color: var(--gray-20);
    font-size: var(--font-size-sm);
  }
  .b-timeaxissubgrid .b-grid-row {
    border-bottom-color: transparent;
  }
  .b-grid-body-container:focus .b-grid-row.b-selected {
    background: none;
  }
  .b-gridbase .b-grid-row:not(.b-group-row).highlight .b-grid-cell {
    background: var(--blue-10);
    animation: highlighting 2s ease-out;
  }
  .b-gridbase .b-grid-row:not(.b-group-row).b-hover,
  .b-gridbase .b-grid-row:not(.b-group-row).hover {
    .b-grid-cell:not(.b-focused),
    .b-grid-cell.b-focused {
      transition: none;
      background: var(--blue-10) !important;
    }
  }

  .b-grid-cell.b-focused:after {
    border: none;
  }

  @keyframes highlighting {
    50% {
      background: var(--blue-10);
    }
    100% {
      background: none;
    }
  }

  .b-grid-row .b-tree-cell-inner {
    width: 100%;
    .b-tree-cell-value {
      max-width: calc(100% - 7px);
    }
    .b-react-portal-container {
      width: 100%;
    }
  }
  .b-tree-parent-row .b-tree-cell-inner {
    width: 100%;
    .b-tree-cell-value {
      max-width: 88%;
    }
    .b-react-portal-container {
      width: 100%;
    }
  }
  .b-grid-cell {
    font-weight: var(--font-weight-normal);
    padding-left: var(--spacing-05);
  }
  .b-tree-leaf-cell .b-tree-cell-value {
    padding-left: var(--spacing-03);
  }
  .b-grid-splitter {
    pointer-events: none;
  }
  .b-gridbase .b-grid-subgrid-normal {
    .b-grid-row.user.loading-skeleton:not(.b-group-row) {
      .b-grid-cell {
        height: 48px;
      }
    }
    .b-grid-row.demand_role.loading-skeleton:not(.b-group-row) {
      .b-grid-cell {
        height: 40px;
      }
    }
    .b-grid-row.user.loading-skeleton:not(.b-group-row),
    .b-grid-row.demand_role.loading-skeleton:not(.b-group-row) {
      .b-grid-cell {
        position: relative;
        background: var(--coolest-gray-10);
        &::after {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          transform: translateX(-100%);
          background: linear-gradient(
            90deg,
            var(--white-100) 0%,
            var(--white-20) 20%,
            var(--white-50) 60%
          );
          animation: shimmer 2s infinite;
          content: '';
        }
        @keyframes shimmer {
          100% {
            transform: translateX(100%);
          }
        }
      }
    }
  }
  .b-grid-header-text-content {
    font-size: var(--font-size-base);
    font-weight: var(--font-weight-bold);
    color: var(--gray-100);
  }
`;
export const ResourceSpecificGridStyles = css`
  .b-gridbase {
    .assign_user_or_placeholder,
    .role,
    .assign_project {
      &.b-grid-row.b-hover .b-grid-cell:not(.b-focused),
      &.b-grid-row.b-hover.b-selected .b-grid-cell:not(.b-focused),
      &.b-grid-row.b-hover .b-grid-cell.b-focused {
        background: none;
      }
    }
  }
  .b-grid-subgrid-locked {
    .b-grid-row {
      &.role {
        background: var(--coolest-gray-10) !important;
        color: var(--gray-70);
        .b-tree-expander .b-icon {
          width: 16px;
          height: 16px;
        }
        .b-grid-cell {
          padding-left: calc(var(--spacing-06) + var(--spacing-01));
        }
      }
      .non-clickable {
        .b-tree-expander {
          display: none;
        }
      }
      .full-width {
        width: 100% !important;
      }
      .no-right-border {
        border-right: none;
      }
      .b-grid-cell[data-column-id='allocatedHours'] {
        padding: 0;
        .b-react-portal-container {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .b-grid-subgrid-normal {
    .b-grid-row {
      &.team,
      &.user,
      &.people-view.project {
        &.auto-allocate {
          cursor: not-allowed;
        }
      }
    }
  }
`;
export const ShowActionOnHover = css`
  .b-grid-row {
    .primary-action[disabled] {
      pointer-events: none;
      color: var(--warning-border-color);
      svg {
        fill-opacity: 1;
      }
    }
    .primary-action,
    .cell-actions:not(.ant-dropdown-open) {
      visibility: hidden;
    }
    &.b-hover,
    &.hover {
      .cell-actions,
      .primary-action {
        visibility: visible;
      }

      .actions-container {
        background-color: var(--white-100);
      }
    }
  }
`;
